import { Component, OnInit } from '@angular/core';
import { WalletService } from '../../../services/wallet.service'
import { IproposalMethod } from '../../../services/bodyAll';
import { NavigationExtras } from '@angular/router';
import { NavController,  ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-methods',
  templateUrl: './methods.page.html',
  styleUrls: ['./methods.page.scss'],
})
export class MethodsPage implements OnInit {
  methods: IproposalMethod[] = []
  isModal = false
  forSelect = false
  operation // sale buy

  constructor(
    public modalController: ModalController,
    public navParams: NavParams,
    private navCtrl: NavController,
    private walletService: WalletService,

  ) {
    console.log(this.navParams.get('is_modal'))
    this.isModal = this.navParams.get('is_modal')
    this.forSelect = this.navParams.get('for_select')
    this.operation = this.navParams.get('operation')
    
  }

  ngOnInit() {
    this.getMethods()
  }
  /**
   * GETTERS
   */
  //OBTENER METHODOS DISPONIBLES
  getMethods(event=null){
    //metodos del usuario
    if(this.operation == 'buy'){
      this.walletService.getMethods().subscribe(
        (data:any)=>{
  
          if(event)
            event?.target?.complete();
          if(data){
            if(data.methods?.length>0)
              this.methods = data.methods
          }
        },
        error=>{
  
          if(event)
            event?.target?.complete();
          console.log(error)
          if(error.status == 0){
            this.initByTest()
          }
        }
      )
    }else{
    //meyodos generales disponibles
      this.walletService.getMethodsp2p().subscribe(
        (data:any)=>{
  
          if(event)
            event?.target?.complete();
          if(data){
            if(data.data?.methods?.length>0)
              this.methods = data.data.methods
          }
        },
        error=>{
  
          if(event)
            event?.target?.complete();
          console.log(error)
          if(error.status == 0){
            this.initByTest()
          }
        }
      )

    }
  }

  /**
   * OPTIONS
   */
  editMethod(met){
    
    let navigationExtras: NavigationExtras  = {
      queryParams: {
        method: JSON.stringify(met)
      }
    };

    this.navCtrl.navigateForward('/p2p/methods-edit', navigationExtras);
  }

  addMethodPay(){
    this.closeModal()
    this.navCtrl.navigateForward('/p2p/methods-add');
  }

  initByTest(){
    return
    this.methods = [{
      description: "Efecty",
      value: "efecty",
      color: "success",
      fullname: "nametest lastnametest",
      document_id: "12123123",
      document_type: "CC",
      direccion: "CUCUTA"
    },{
      description: "Bancolombia",
      value: "bancolombia",
      fullname: "nametest lastnametest",
      document_id: "12123123",
      document_type: "CC",
      direccion: "CUCUTA",
      account_number: 123412341234,
      account_type: "AHORRO"
    },{
      description: "Nequi",
      value: "nequi" ,
      fullname: "nametest lastnametest",
      document_id: "12123123",
      document_type: "CC",
      direccion: "CUCUTA",
      account_number: 123412341234,
      color: "warning",
      account_type: "AHORRO"
    }]
  }

  async closeModal(param=null){
    await this.modalController.dismiss(param)
  }

  selectMethod(method){
    this.closeModal(method)
  }

  handleRefresh(event){
    this.getMethods(event)

  }

}
